<div style="padding: 24px">
  <mat-icon style="float: right; cursor: pointer" mat-dialog-close
    >close</mat-icon
  >
  <h5 class="heading">{{ "Terms and condition" | translate }}</h5>
  <div *ngIf="term" class="subheading" [innerHTML]="term.content"></div>

  <!-- <p class="subheading" >{{ term.content }}</p> -->
</div>
